// extracted by mini-css-extract-plugin
export var swiperProgress = "ServicePage-module--swiperProgress--3pqn8";
export var proudOfSubTitle = "ServicePage-module--proudOfSubTitle--1kSeb";
export var contact = "ServicePage-module--contact--15G0_";